import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from 'src/lib/utils';

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  options: SelectOption[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
}

export function Select({
  options,
  value,
  onValueChange,
  placeholder,
  className,
  ...props
}: SelectProps): React.ReactElement {
  return (
    <div className="relative inline-flex min-w-[180px]">
      <select
        {...props}
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        className={cn(
          'h-9 w-full appearance-none rounded-md border border-gray-200 bg-white py-1.5 pl-3 pr-8 text-sm text-gray-900 shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-200',
          className
        )}
      >
        {placeholder ? (
          <option value="">
            {placeholder}
          </option>
        ) : null}
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2 top-1/2 size-4 -translate-y-1/2 text-gray-500" />
    </div>
  );
}
